import React, { useEffect, useRef, useState } from "react";
import DownloadExcel from "../../../../Extra/DownloadExcel";
import { getCurrentDate } from "../../../../Utilitie";

const DateWiseJBB = ({ currentPage, entriesPerPage, data, keyName }) => {
  const [keys, setKeys] = useState([]);
  const tableRef = useRef();

  useEffect(() => {
    let temp = [];
    if (keyName === "JUMBO") {
      temp = ["JUMBO_RECD", "JUMBO_IRE", "JUMBO_Y_DAY_O_B"];
    } else if (keyName === "BTPN") {
      temp = ["BTPN_RECD", "BTPN_IRE", "BTPN_Y_DAY_O_B"];
    } else if (keyName === "NBOX") {
      temp = ["NBOX_RECD", "NBOX_IRE", "NBOX_Y_DAY_O_B"];
    }

    setKeys(temp);
  }, [keyName]);
  const [rawdata, setRawdata] = useState([]);

  useEffect(() => {
    if (Array.isArray(data)) {
      setRawdata(data);
    }
  }, [data]);

  const totals = keys.reduce((acc, key) => {
    acc[key] = rawdata.reduce((sum, row) => sum + (row[key] || 0), 0);
    return acc;
  }, {});

  const totalB = totals[keys[1]] || 0;
  const totalC = totals[keys[2]] || 0;
  const totalBCPercentile =
    totalC !== 0 ? `${Math.round((totalB / totalC) * 100)}%` : "—";
  const indexOfLastEntry = currentPage * entriesPerPage;
  const indexOfFirstEntry = indexOfLastEntry - entriesPerPage;
  const currentData = rawdata.slice(indexOfFirstEntry, indexOfLastEntry);

  return (
    <div style={{}} className="table-responsive  m-2 p-1 newUiBodyNM ">
      <h2 className=" bg-dark text-white text-center m-0 ">{keyName}</h2>
      <table
        className="table newUiTable table-striped table-bordered  table-hover"
        ref={tableRef}
      >
        <thead>
          <tr
            className="table-dark"
            style={{
              maxWidth: "50px",
              textAlign: "center",
              verticalAlign: "middle",
            }}
          >
            <th style={{ minWidth: "80px" }}>Date</th>
            {keys.map((key) => (
              <th className="text-wrap" key={key}>
                {key
                  .replace("_", " ")
                  .replace("_", " ")
                  .replace("_", " ")
                  .replace("_", " ")}
              </th>
            ))}
            <th>Percentile</th>
          </tr>
        </thead>
        <tbody>
          {currentData.map((row, index) => {
            const b = row[keys[1]] || 0;
            const c = row[keys[2]] || 0;
            const bcPercentile =
              c !== 0 ? `${Math.round((b / c) * 100)}%` : "—";

            return (
              <tr key={index}>
                <td>{row.DATE.slice(0, 10)}</td>
                {keys.map((key) => (
                  <td key={key}>{row[key] || 0}</td>
                ))}
                <td>{bcPercentile}</td>
              </tr>
            );
          })}

          <tr className="table-secondary fw-bold">
            <td>Total</td>
            {keys.map((key) => (
              <td key={key}>{totals[key]}</td>
            ))}
            <td>{totalBCPercentile}</td>
          </tr>
        </tbody>
      </table>
      <DownloadExcel
        tableRef={tableRef}
        fileName={`IRE (${keyName})  - ${getCurrentDate()}`}
      />
    </div>
  );
};

export default DateWiseJBB;
